<script setup lang="ts">
import bwipjs from '@bwip-js/browser'

const props = withDefaults(defineProps<{
  value: string
  label?: string
}>(), {
  label: undefined,
})

const barcodeViewBox = ref('0 0 1 1')
const barcodePaths = ref<string[]>([])

function renderBarcode() {
  if (!props.value) {
    barcodePaths.value = []
    return
  }

  const markup = bwipjs.toSVG({
    bcid: 'pdf417',
    text: props.value,
    scale: 2,
    columns: 5,
    eclevel: 3,
    rowmult: 3,
    paddingwidth: 2,
    paddingheight: 2,
    barcolor: 'FFFFFF',
  })
  const document = new DOMParser().parseFromString(markup, 'image/svg+xml')
  const svg = document.documentElement

  barcodeViewBox.value = svg.getAttribute('viewBox') ?? '0 0 1 1'
  barcodePaths.value = Array.from(svg.querySelectorAll('path'))
    .map(path => path.getAttribute('d'))
    .filter((path): path is string => !!path)
}

onMounted(renderBarcode)
watch(() => props.value, renderBarcode, { flush: 'post' })
</script>

<template>
  <svg
    v-if="barcodePaths.length"
    :viewBox="barcodeViewBox"
    class="block size-full"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    :aria-label="label ?? `PDF417-Barcode ${value}`"
  >
    <path
      v-for="(path, index) in barcodePaths"
      :key="index"
      :d="path"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
</template>
